import classNames from 'classnames';

import Typography, { TypographyProps } from './Typography';

import styles from '../../styles/typography/card-subtitle.module.css';

function CardSubtitleTypography({ className = null, ...props }: TypographyProps) {
    return <Typography tag="h4" className={classNames([styles.container, className])} {...props} />;
}

export default CardSubtitleTypography;
